const products = [
    {
        name        : 'pos',
        text        : 'POS',
        url         : 'https://pos.simprasuite.com/?skipRedirection=true',
        desc        : {
            tr: 'İşini yönet',
            en: 'Manage your business',
        },
        landing     : 'https://simprasuite.com.tr/restoran-otomasyonu/pos-sistemi/'
    },
    {
        name        : 'inventory',
        text        : 'Inventory',
        url         : 'https://inventory.simprasuite.com/login?skipRedirection=true',
        desc        : {
            tr: 'Envanterini yönet',
            en: 'Manage your inventory',
        },
        landing     : 'https://simprasuite.com.tr/restoran-otomasyonu/stok-takip-programi/'
    },
    {
        name        : 'link',
        text        : 'Link',
        url         : 'https://backoffice.simpralink.com/?skipRedirection=true',
        desc        : {
            tr: 'Ödemelerini yönet',
            en: 'Manage your payments',
        },
        landing     : 'https://simprasuite.com.tr/link/'
    },
    {
        name        : 'c&p',
        text        : 'Check & Place',
        url         : 'hhttps://www.checkandplace.com/?skipRedirection=true',
        desc        : {
            tr: 'Rezervasyonları yönet',
            en: 'Manage your bookings',
        },
        landing     : 'https://simprasuite.com.tr/restoran-rezervasyon-sistemi/'
    },
    /* {
        name        : 'loyalty',
        text        : 'Loyalty',
        url         : 'http://simprasuite.com',
        desc        : 'Sadakat yönetimi',
        landing     : 'https://simprasuite.com.tr/restoran-otomasyonu/musteri-sadakat-programi/'
    }, */
    {
        name        : 'vendormarket',
        text        : 'Market',
        url         : 'https://vendor-market.simprasuite.com/',
        desc        : {
            tr: 'Tedarikçiden satın al',
            en: 'Buy from the supplier',
        },
        landing     : 'https://simprasuite.com.tr/'
    }
]

export default products